import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {EventService} from "../services/event.service";
import {ColDef, GridReadyEvent} from "ag-grid-community";
import {interval, Observable, Subscription, take} from "rxjs";
import {AgGridAngular} from "ag-grid-angular";
import {MatDialog} from "@angular/material/dialog";
import {EventDialogComponent} from "./event-dialog/event-dialog.component";
import {BtnCellRendererComponent} from "../shared/table/button-cell-renderer.component";
import {UserService} from "../services/user.service";
import {StorageService} from "../services/storage.service";
import {SyncService} from "../services/sync.service";

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss']
})
export class EventsComponent implements OnInit, OnDestroy {

  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;
  private subscription: Subscription | undefined;

  public columnDefs: ColDef[] = [
    {
      field: 'id',
      width: 150,
      minWidth: 150,
      maxWidth: 100,
      sortable: true,
      filter: true,
    },
    { field: 'name' },
    {
      field: 'type',
      filter: true,
    },
    { field: 'externalId' },
    {
      field: 'hubspotId',
      cellRenderer: function(params: any) {
        console.log(params);
        if (params.data.type === "unsubscribe") {
          return '<a href="https://app-eu1.hubspot.com/contacts/TODO/record/TODO/deals/' + params.value + '" target="_blank">' + params.value + '</a>'
        } else {
          return params.value;
        }
      }
    },
    { field: 'value' },
    { field: 'full' },
    { field: 'data' },
    { field: 'status' },
    { field: 'createdAt' },
    {
      field: '',
      sortable: false,
      resizable: false,
      width: 100,
      maxWidth: 100,
      cellRenderer: BtnCellRendererComponent,
      cellRendererParams: {
        clicked: (data: any) => {
          console.log(data);
          this.syncEvent(data.id);
        },
        icon: 'play_arrow',
      },
    }
  ];

  // DefaultColDef sets props common to all Columns
  public defaultColDef: ColDef = {
    resizable: true,
    sortable: false,
    filter: false,
  };

  public rowData$!: Observable<any[]>;

  eventType = 'contact';

  constructor(
    private eventService: EventService,
    private syncService: SyncService,
    private userService: UserService,
    private storageService: StorageService,
    private matDialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.agGrid.api.sizeColumnsToFit();
    this.getEvents();
  }

  getEvents() {
    const filter: any = {
      type: this.eventType
    }
    const customerId = this.userService.getCustomerId();
    if (customerId) {
      const hubspotIds: number[] = [];
      this.storageService.getCustomerIntegrations().forEach((integration: any) => {
        hubspotIds.push(integration.id);
      });
      filter.hubspotCustomerId = hubspotIds;
    }
    const order = [['createdAt', 'DESC']];
    this.eventService.getEvents(filter, 100, order).subscribe((res: any) => {
      console.log(res);
      this.agGrid.api.setRowData(res);
      if (!this.subscription) {
        const source = interval(20000);
        this.subscription = source.subscribe(val => this.getEvents());
      }
    });
  }

  onCellEditingStopped(event: any) {
    this.eventService.updateEvent(event.data.id, event.data).subscribe((res: any) => {
      console.log(res);
    });
  }

  onCellDoubleClicked(event: any) {
    console.log(event);
    const data = {
      event: event.data,
      field: event.colDef.field,
      type: 'view'
    }
    this.matDialog.open(EventDialogComponent, {
      width: '800px',
      data: data
    });
  }

  openEventDialog() {
    this.matDialog.open(EventDialogComponent, {
       width: '600px',
     });

    // load data after modal closed
    this.matDialog.afterAllClosed.pipe(take(1)).subscribe(() => {
      this.getEvents();
    });
  }

  syncEvent(id: number) {
    this.syncService.syncEvent(id).subscribe((res: any) => {
      console.log(res);
    });
  }

}
